import { createSelector } from 'reselect'

export const getConjoint = state => state.pages.conjoint

export const getTokenConjoint = createSelector([
	getConjoint
], conjoint => conjoint.token)
